export default __webpack_public_path__ + "static/media/cholet12.5a5228b5.jpg";